
// app/host-route-map.token.ts
import { InjectionToken, inject } from '@angular/core';
import { HostRouteConfig, HostRouteConfigService } from './host-route-config.service';

export const HOST_ROUTE_CONFIG = new InjectionToken<HostRouteConfig>(
  'HOST_ROUTE_CONFIG',
  {
    providedIn: 'root',
    factory: () => inject(HostRouteConfigService).getConfig(),
  }
);
